import request from "../../../../utils/api";

const url = "events";

export const getEvents = params => request(url, { params });
export const postEvents = body => request(url, { method: 'post', body });
export const putEvents = body => request(`${url}/${body.get('event[id]')}`, { method: 'put', body });
export const deleteEvents = body => request(`${url}/${body}`, { method: 'delete' });